import * as SwitchPrimitive from "@radix-ui/react-switch"
import { clsx } from "clsx"

import type { SX } from "../../theme"
import styles from "./Switch.module.css"

export interface SwitchProps {
  id?: string
  size?: "small" | "medium"
  disabled?: boolean
  checked?: boolean
  sx?: SX
  onCheckedChange?(checked: boolean): void
}

export function Switch(props: SwitchProps) {
  const { size = "medium", sx, ...otherProps } = props

  return (
    <SwitchPrimitive.Root
      {...otherProps}
      style={sx}
      className={clsx(styles.root, styles[size])}
    >
      <SwitchPrimitive.Thumb className={clsx(styles.thumb, styles[size])} />
    </SwitchPrimitive.Root>
  )
}
